// layouts/DashboardLayout.jsx
import React, { ReactNode, useState } from "react";

import Header from "./Header";
import Sidebar from "./Sidebar";
type DashboardLayoutProps = {
  children: ReactNode;
};

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <Header toggleSidebar={toggleSidebar} />
      <Sidebar open={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <main style={{ padding: "16px" }}>{children}</main>
    </>
  );
};

export default DashboardLayout;
